// Claude in Chrome : l'extension de Claude ouvre son panneau à droite de Chrome, sur
// l'abonnement de la personne, et voit la page ouverte. Là où elle est installée, l'appli
// passe par elle plutôt que par son propre assistant (payé à l'API) ; ailleurs (Safari,
// Firefox, Chrome sans l'extension), le bouton « Assistant » reste.
//
// Une page ne voit pas les extensions, sauf les fichiers qu'une extension rend lisibles à
// toutes les pages : ceux de Claude in Chrome (manifeste, web_accessible_resources) portent
// une empreinte de construction qui peut changer à une mise à jour. Aucune réponse : le
// bouton « Assistant » revient, rien ne casse ; relever alors les noms dans le manifeste de
// l'extension installée (dossier Extensions du profil Chrome) et les ajouter ici.

export const ID_CLAUDE_IN_CHROME = 'fcoeoabgfenejglbffodgkkbkcdhcgfn'

/** Fichiers lisibles depuis toute page (versions 1.0.100 à 1.0.102). */
export const FICHIERS_CLAUDE_IN_CHROME = [
  'assets/accessibility-tree.js-B-oUarrX.js',
  'assets/agent-visual-indicator.js-uaVFxZ2f.js',
  'assets/agent-visual-indicator.js-BKHK7gXk.js',
]

/** Vrai si l'un des fichiers répond : l'extension est installée et active dans ce navigateur. */
export async function detecterClaudeInChrome(lire: typeof fetch | undefined): Promise<boolean> {
  if (!lire) return false
  const essais = FICHIERS_CLAUDE_IN_CHROME.map(async (f) => {
    const r = await lire(`chrome-extension://${ID_CLAUDE_IN_CHROME}/${f}`)
    if (!r.ok) throw new Error(`${r.status}`)
  })
  try {
    await Promise.any(essais)
    return true
  } catch {
    return false
  }
}

/** Raccourci par défaut de l'extension (commande toggle-side-panel de son manifeste). */
export const raccourciClaude = (plateforme: string) =>
  /mac|iphone|ipad/i.test(plateforme) ? '⌘E' : 'Ctrl+E'
